<template>
  <div class="main">
    <c-panel>
      <propostas></propostas>
    </c-panel>
  </div>
</template>

<script>
import propostas from "./propostas"

export default {
  components: { propostas }
}
</script>

